import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface UserConnection {
  socketId: string;
  ip: string;
  country: string;
  browser: string;
  os: string;
  deviceType: string;
  connectedAt: string;
}

export interface ConnectedUser {
  userId: number;
  cognitoId: string;
  email: string;
  nombre: string;
  apellidos: string;
  tipoId: string;
  isOperator: boolean;
  tabs: number;
  connections: UserConnection[];
}

export interface OnlineUsersResponse {
  stage: string;
  totalConnections: number;
  uniqueUsers: number;
  operators: number;
  clientsVE: number;
  clientsCL: number;
  users: ConnectedUser[];
}

export interface ConnectionDetail {
  ip: string;
  country: string;
  browser: string;
  os: string;
  deviceType: string;
  connectedAt: string;
}

export interface ConnectionHistoryRecord {
  id: number;
  userId: number;
  cognitoId: string;
  email: string;
  nombre: string;
  apellidos: string;
  tipoId: string;
  isOperator: boolean;
  date: string;
  firstConnectionAt: string;
  lastConnectionAt: string;
  connectionCount: number;
  connectionDetails: ConnectionDetail[];
}

export interface ConnectionHistoryResponse {
  data: ConnectionHistoryRecord[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface ConnectionHistoryParams {
  page?: number;
  limit?: number;
  dateFrom?: string;
  dateTo?: string;
  tipoId?: string;
  userId?: string;
  isOperator?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConnectedUsersService {
  private baseUrl = `${environment.apiNest}notifications/online`;
  private historyUrl = `${environment.apiNest}notifications/history`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<OnlineUsersResponse> {
    return this.http.get<OnlineUsersResponse>(this.baseUrl);
  }

  getVE(): Observable<OnlineUsersResponse> {
    return this.http.get<OnlineUsersResponse>(`${this.baseUrl}/ve`);
  }

  getCL(): Observable<OnlineUsersResponse> {
    return this.http.get<OnlineUsersResponse>(`${this.baseUrl}/cl`);
  }

  getOperators(): Observable<OnlineUsersResponse> {
    return this.http.get<OnlineUsersResponse>(`${this.baseUrl}/operators`);
  }

  getMyConnections(params: { page?: number; limit?: number }): Observable<ConnectionHistoryResponse> {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.limit) httpParams = httpParams.set('limit', params.limit.toString());
    return this.http.get<ConnectionHistoryResponse>(
      `${environment.apiNest}notifications/my-connections`,
      { params: httpParams },
    );
  }

  getHistory(params: ConnectionHistoryParams): Observable<ConnectionHistoryResponse> {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.limit) httpParams = httpParams.set('limit', params.limit.toString());
    if (params.dateFrom) httpParams = httpParams.set('dateFrom', params.dateFrom);
    if (params.dateTo) httpParams = httpParams.set('dateTo', params.dateTo);
    if (params.tipoId) httpParams = httpParams.set('tipoId', params.tipoId);
    if (params.userId) httpParams = httpParams.set('userId', params.userId);
    if (params.isOperator !== undefined) httpParams = httpParams.set('isOperator', params.isOperator.toString());
    return this.http.get<ConnectionHistoryResponse>(this.historyUrl, { params: httpParams });
  }
}
